import {
    Divider,
    BreadcrumbLink,
    Breadcrumb,
    Heading,
    HStack,
    Text,
    VStack,
    Wrap,
    BreadcrumbItem,
    Image,
    Box,
    StackDivider,
    Tag,
    Link as ChakraLink,
    Icon,
    Button,
    Tooltip,
} from '@chakra-ui/react';
import ReactMarkdown, { Components } from 'react-markdown';
import { Graphics } from '../../../../../../config/svg';
import { VAROS_YELLOW } from '../../../../../../config';
import { ReportingViewBaseConfig } from '../../../base';
import { RecordOverlayViewProps } from './recordOverlayProps';
import { RiDoubleQuotesL, RiDoubleQuotesR } from 'react-icons/ri';
import React from 'react';
import { createValueItemView } from '../../document/detail/value';
import { AiOutlineFullscreen } from 'react-icons/ai';

export function createRecordOverlayView(
    config: ReportingViewBaseConfig
): React.FC<RecordOverlayViewProps> {
    const {
        UI: {
            Application: { Anchor, Link },
        },
        Container: {
            Property: { Value: ValueContainer },
        },
    } = config;

    const ValueItem = createValueItemView({
        ...config,
        // NOTE no tooltip since we're rendering the property next to the value
        tooltip: false,
        compact: false,
    });

    return (props) => {
        return (
            <VStack
                w="full"
                spacing={{ base: 4, md: 8, xl: 12, '2xl': 16 }}
                align="start"
            >
                <VStack w="full" align="start" spacing={4} pr={12}>
                    <VStack align="start" spacing={1}>
                        <HStack>
                            <Text
                                fontWeight="semibold"
                                fontSize="sm"
                                color="blue.200"
                                userSelect="none"
                            >
                                {props.collection.label}
                            </Text>
                        </HStack>
                        <Heading
                            fontSize="xl"
                            fontWeight="semibold"
                            color="whiteAlpha.900"
                            wordBreak="break-word"
                        >
                            {props.title}
                        </Heading>
                    </VStack>
                    <Link {...props.open.link}>
                        <Button
                            size="md"
                            bg="none"
                            borderWidth={1}
                            borderColor="whiteAlpha.300"
                            color="whiteAlpha.800"
                            leftIcon={
                                <Icon
                                    fontSize="lg"
                                    color="whiteAlpha.800"
                                    as={AiOutlineFullscreen}
                                />
                            }
                            _hover={{
                                bg: 'whiteAlpha.50',
                            }}
                        >
                            Fullscreen
                        </Button>
                    </Link>
                </VStack>
                <VStack align="start" w="full" spacing={1}>
                    {props.property.items.map((item) => (
                        <HStack key={item.id} w="full" spacing={2}>
                            <Tooltip
                                placement="top"
                                openDelay={300}
                                px={2}
                                py={1}
                                bg="gray.50"
                                borderRadius="md"
                                color="gray.900"
                                label={item.description}
                                isDisabled={!item.description}
                            >
                                <HStack
                                    userSelect="none"
                                    flex={1}
                                    px={3}
                                    py={2}
                                    _hover={{ bg: 'whiteAlpha.50' }}
                                    borderRadius="md"
                                    fontWeight="medium"
                                    color="whiteAlpha.700"
                                    spacing={3}
                                >
                                    <Icon fontSize="lg" as={item.Icon} />
                                    <Text noOfLines={1}>{item.label}</Text>
                                </HStack>
                            </Tooltip>
                            <HStack
                                flex={2}
                                px={3}
                                py={2}
                                _hover={{ bg: 'whiteAlpha.50' }}
                                borderRadius="md"
                                color="whiteAlpha.600"
                                spacing={3}
                                wordBreak="break-word"
                            >
                                <ValueContainer {...item.value} as={ValueItem} />
                            </HStack>
                        </HStack>
                    ))}
                </VStack>
            </VStack>
        );
    };
}
